import React from 'react';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import useAdmin from '../../hooks/useAdmin';

const AdminViewHelp = () => {
  const { isAdmin, adminViewActive } = useAdmin();
  
  // Only render this component for admins
  if (!isAdmin) return null;
  
  return (
    <div className="admin-view-help">
      <div className="help-card">
        <div className="help-card-header">
          <HiOutlineInformationCircle size={24} />
          <h3>Admin View Mode</h3>
        </div>
        <div className="help-card-body">
          <p>
            As an administrator, you can switch between <strong>Admin View</strong> and <strong>User View</strong> modes 
            using the toggle in the sidebar.
          </p>
          
          <div className="current-status">
            <span className="label">Current mode:</span>
            <span className={`status ${adminViewActive ? 'admin' : 'user'}`}>
              {adminViewActive ? 'Admin View' : 'User View'}
            </span>
          </div>
          
          <div className="mode-description">
            <h4>What's the difference?</h4>
            <ul>
              <li>
                <strong>Admin View:</strong> Provides access to all administrative pages and tools for 
                managing employees, content, and system settings.
              </li>
              <li>
                <strong>User View:</strong> Shows the interface as regular employees see it, allowing you 
                to test and experience the portal from a user's perspective.
              </li>
            </ul>
          </div>
          
          <div className="mode-tip">
            <p>
              <strong>Tip:</strong> When switching from Admin View to User View while on an admin page, 
              you will be automatically redirected to the home page.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminViewHelp; 